
import { computed, defineComponent, ref } from "vue";
import {curr_bg} from "../globals";

export default defineComponent({
  name: "BgGoblin",
  props: {
    id: {
      type: Number,
      required: true 
    }
  },
  setup(props) {
    const on = computed(() => props.id == curr_bg.value);

    const showclass = computed(() => on.value ? ["show"] : ["hide"]);

    return {
      on,
      showclass
    };
  }
});
